import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge, Flex, Text, Box } from '@chakra-ui/react';
import { MapPin, Stack, ShieldCheck } from 'phosphor-react';
import { RiFileList3Line, RiFundsLine } from 'react-icons/ri';
import { PageBox } from '../../../../../components/pageBox';
import { ReturnButton } from '../../../../../components/buttons/ReturnButton';
import { DashboardCard } from '../../../../../components/dashboardCard';
import { useAuth } from '../../../../../providers/auth';

interface IcmsModule {
  title: string;
  path: string;
  icon: React.ReactNode;
  bgColor: string;
  comingSoon?: boolean;
}

export function IcmsHomePage() {
  const navigate = useNavigate();
  const { hasPermission, isAdmin } = useAuth();

  const modules: IcmsModule[] = [
    {
      title: 'Livros Fiscais',
      path: '/modulesHome/supervisor/icms/livros-fiscais',
      icon: <RiFileList3Line color="#1976D2" className="size-10" />,
      bgColor: '#E3F2FD',
    },
    {
      title: 'DIFAL',
      path: '/modulesHome/supervisor/icms/difal',
      icon: <MapPin size={40} color="#F57C00" />,
      bgColor: '#FFF3E0',
    },
    {
      title: 'Acumuladores',
      path: '/modulesHome/supervisor/icms/acumuladores',
      icon: <Stack size={40} color="#9C27B0" />,
      bgColor: '#F3E5F5',
    },
    {
      title: 'Regime Especial',
      path: '/modulesHome/supervisor/icms/regime-especial',
      icon: <ShieldCheck size={40} color="#4CAF50" />,
      bgColor: '#E8F5E9',
    },
  ];

  const visibleModules = modules.filter(module => {
    if (isAdmin()) return true;
    return hasPermission(module.path);
  });

  return (
    <PageBox>
      <Flex align="center" pb={5}>
        <ReturnButton previousPage="/modulesHome/supervisor" />
        <Box h="full">
          <Flex align="center" justify="center" borderRadius="full" p={3} bg="#E8EFFF">
            <RiFundsLine color="#5D7FFF" className="size-8" />
          </Flex>
        </Box>
        <Flex direction="column" justify="center" gap={1} pl={2}>
          <Text fontWeight="bold" fontSize="16px">
            ICMS
          </Text>
          <Text fontSize="12px" color="gray.500">
            {visibleModules.length > 0
              ? 'Selecione o módulo que deseja acessar'
              : 'Você não tem acesso a nenhum módulo desta seção.'}
          </Text>
        </Flex>
      </Flex>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {visibleModules.map(module => {
          if (module.comingSoon) {
            return (
              <Box key={module.path} position="relative" opacity={0.55}>
                <Badge
                  position="absolute"
                  top={3}
                  right={3}
                  colorScheme="gray"
                  fontSize="10px"
                  px={2}
                  py={0.5}
                  borderRadius="full"
                  zIndex={1}
                  textTransform="uppercase"
                >
                  Em breve
                </Badge>
                <Box
                  className="flex flex-col items-center gap-4 rounded-3xl border-2 border-solid bg-body p-5 lg:flex-row lg:gap-4"
                  cursor="not-allowed"
                  pointerEvents="none"
                >
                  <div className="flex-shrink-0">
                    <div
                      className="flex items-center justify-center rounded-full p-3"
                      style={{ backgroundColor: module.bgColor }}
                    >
                      {module.icon}
                    </div>
                  </div>
                  <div className="flex w-full flex-col items-center gap-3 lg:items-start lg:pr-1">
                    <Text
                      fontWeight="bold"
                      fontSize={{ base: '15px', md: '16px' }}
                      lineHeight="1.3"
                      textAlign={{ base: 'center', lg: 'left' }}
                      color="gray.500"
                    >
                      {module.title}
                    </Text>
                  </div>
                </Box>
              </Box>
            );
          }
          return (
            <DashboardCard
              key={module.path}
              title={module.title}
              value=""
              onClick={() => navigate(module.path)}
            >
              <div
                className="flex items-center justify-center rounded-full p-3"
                style={{ backgroundColor: module.bgColor }}
              >
                {module.icon}
              </div>
            </DashboardCard>
          );
        })}
      </div>
    </PageBox>
  );
}
